import React, { useMemo } from 'react';

import { Select } from '../Select/Select';

interface EnhancedSelectProps<T> {
    nameSelector: (item: T) => string;
    idSelector: (item: T) => string;
    value: string;
    namespace: string;
    defaultValue?: {
        label: string;
        value: string;
    };
    items: T[];
    onChange: (value: string) => void;
    disabled?: boolean;
}

function EnhancedSelect<T>({
    nameSelector,
    idSelector,
    value,
    namespace,
    defaultValue,
    items,
    onChange,
    ...selectProps
}: EnhancedSelectProps<T>) {
    const options = useMemo(() => {
        const optionsArr = [];
        if (defaultValue) {
            optionsArr.push({ value: defaultValue.value, text: defaultValue.label });
        }
        items.forEach((item) => {
            optionsArr.push({ value: idSelector(item), text: nameSelector(item) });
        });
        return optionsArr;
    }, [defaultValue, idSelector, items, nameSelector]);

    return (
        <Select
            namespace={namespace}
            placeholder="Не выбрано"
            type="radio"
            value={value}
            onChange={(val) => {
                onChange(val);
            }}
            options={options}
            {...selectProps}
        />
    );
}

export default EnhancedSelect;
